<div class="page-wrapper">
  <app-header></app-header>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</div>

<app-mobile></app-mobile>

<app-searchbox></app-searchbox>

<a href="#" data-target="html" class="scroll-to-target scroll-to-top">
  <span class="scroll-to-top__text">{{ "monter" | translate }}</span>
  <span class="scroll-to-top__wrapper"><span class="scroll-to-top__inner"></span></span>
</a>

<!-- ── Loader global (HTTP + navigation entre pages) ────────────────── -->
<app-loader></app-loader>
